import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import AvgProgress from '../../components/AvgProgress';
import DegreeProgress from '../../components/DegreeProgress';
import Footer from '../../components/Footer';
import Mainmenu from '../../components/Mainmenu';
import Navbar from '../../components/Navbar';
import SelectCities from '../../components/SelectCities';
import SelectCountries from '../../components/SelectCountries';
import SelectGender from '../../components/SelectGender';
import SelectJuries from '../../components/SelectJuries';
import SelectSize from '../../components/SelectSize';
import CourseDocumentPublicButton from '../../components/CourseDocumentPublicButton';
import Modal from 'react-modal';
import { useParams } from 'react-router-dom';

import { getDefaultName, isImage, userAvatar } from '../../utils';
import { loadCourseParticipantsByQuery, loadDegrees } from '../../utils/Network';
import { resolveMediaUrl } from '../../../utils/Network';
import UrlEmbed from '../../components/UrlEmbed';

function courseIdOf(course) {
    if (course == null) return null
    return typeof course === 'object' ? course.id : course
}

function getParticipantDocs(courseparticipant) {
    const courseId = courseIdOf(courseparticipant?.course)
    const docs = courseparticipant?.usertalent?.userdocuments
    if (!Array.isArray(docs) || !docs.length) {
        return { courseDocument: null, userDocument: null }
    }
    for (const userDocument of docs) {
        const cds = Array.isArray(userDocument?.coursedocuments)
            ? userDocument.coursedocuments
            : []
        const match = cds.find((cd) => {
            if (!cd) return false
            if (courseId == null) return true
            return String(courseIdOf(cd.course)) === String(courseId)
        })
        if (match) return { courseDocument: match, userDocument }
    }
    const firstWithCd = docs.find((ud) => ud?.coursedocuments?.[0])
    if (firstWithCd) {
        return {
            courseDocument: firstWithCd.coursedocuments[0],
            userDocument: firstWithCd,
        }
    }
    return { courseDocument: null, userDocument: docs[0] }
}

function RatingsSummary() {
    const { courseId } = useParams();
    const selectedCourseId = parseInt(courseId, 10);
    const [loading, setLoading] = useState(false);
    const [simpleView, setSimpleView] = useState(true);

    const [filter_talent, setFilterTalent] = useState(null);
    const [filter_name, setFilterName] = useState(null);
    const [filter_jury, setFilterJury] = useState(null);
    const [filter_course, setFilterCourse] = useState(Number.isNaN(selectedCourseId) ? null : selectedCourseId);
    const [filter_size, setFilterSize] = useState(30);
    const [filter_gender, setFilterGender] = useState(null);
    const [filter_country, setFilterCountry] = useState(null);
    const [filter_city, setFilterCity] = useState(null);
    const [courseparticipants, setCourseParticipants] = useState(null);
    const [defaultCourseParticipants, setDefaultCourseParticipants] = useState(null);

    const [current_document, setCurrentDocument] = useState(null);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [modal_degrees, setModalDegrees] = useState(false);

    useEffect(() => {
        if (!selectedCourseId || Number.isNaN(selectedCourseId)) {
            return;
        }
        setFilterCourse(selectedCourseId);
        let filter_query = _getFilterQuery(
            filter_size,
            filter_gender,
            filter_jury,
            filter_country,
            filter_city,
            filter_name,
            selectedCourseId
        )
        _getData(filter_query);
    }, [selectedCourseId]);


    const _getData = (filter_query) => {

        if (!filter_query) {
            filter_query = _getFilterQuery()
        }


        setLoading(true)
        loadCourseParticipantsByQuery(filter_query).then(data => {
            if (data.results) {
                setDefaultCourseParticipants(data.results)
                setLoading(false)
                buildReports(data.results)
            }
        })
    }

    const closeModal = () => {
        setModalIsOpen(false)

    }

    const buildReports = (courseparticipants) => {

        if (courseparticipants) {
            courseparticipants.map(item => {
                // let total = item.total_degree
                let people_degree = item.peopledegree_average.degree__avg

                let total = 0;

                if (filter_jury) {
                    let avg_sum = 0;
                    let weight_sum = 0;
                    item.questions && item.questions.forEach(question_item => {
                        avg_sum += question_item.avg * question_item.question.weight
                        weight_sum += question_item.question.weight
                    })

                    total = avg_sum / weight_sum * 10
                }
                else {
                    total = item.total_degree
                }



                if (people_degree > 0)
                    total = total * 0.9 + people_degree
                item.total = total.toFixed(2);
                return item
            })
            courseparticipants = sort(courseparticipants)
        }
        setCourseParticipants(courseparticipants)


    }

    function sort(array, key) {
        return array.sort(function (a, b) {
            //console.log(a["names"][0])
            var x = parseFloat(a["total"]); var y = parseFloat(b["total"]);
            return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        });
    }


    function BadgeClass(value) {

        if (value < 30) {

            return "badge bg-red mr-10 text-4";
        }
        else if (value < 50) {
            return "badge bg-yellow mr-10 text-4";
        }
        else if (value < 70) {
            return "badge bg-light-blue mr-10 text-4";
        }
        else if (value <= 100) {
            return "badge bg-green mr-10 text-4";
        }
        return "badge mr-10";
    }

    const openModal = (current_document, courseparticipant) => {
        loadDegrees(courseparticipant.id).then(degrees => {
            setModalDegrees(degrees)
        })

        setCurrentDocument(current_document)
        setModalIsOpen(true)
    }

    const _getFilterQuery = (
        size = filter_size,
        gender = filter_gender,
        jury = filter_jury,
        country = filter_country,
        city = filter_city,
        name = filter_name,
        course = filter_course || selectedCourseId
    ) => {
        const params = new URLSearchParams();
        params.set('size', String(size || 30));
        if (course) params.set('course', String(course));
        params.set('mode', simpleView ? 'light' : 'full');
        if (gender) params.set('gender', String(gender));
        if (jury) params.set('referee', String(jury));
        if (country) params.set('country', String(country));
        if (city) params.set('city', String(city));
        if (name) params.set('name', String(name));
        return `?${params.toString()}`
    }

    const onValue = (value, name) => {
        // alert(name)
        let filter_query = _getFilterQuery()
        switch (name) {
            case "course":
                setFilterCourse(value)
                break;
            case "jury":
                setFilterJury(value)
                filter_query = _getFilterQuery(filter_size, filter_gender, value, filter_country, filter_city, filter_name)
                _getData(filter_query)
                break;
            case "gender":
                setFilterGender(value)
                filter_query = _getFilterQuery(filter_size, value, filter_jury, filter_country, filter_city, filter_name)
                _getData(filter_query)
                break;
            case "size":
                setFilterSize(value)
                filter_query = _getFilterQuery(value, filter_gender, filter_jury, filter_country, filter_city, filter_name)
                _getData(filter_query)
                break;
            case "country":
                setFilterCountry(value)
                filter_query = _getFilterQuery(filter_size, filter_gender, filter_jury, value, filter_city, filter_name)
                _getData(filter_query)
                break;
            case "city":
                setFilterCity(value)
                filter_query = _getFilterQuery(filter_size, filter_gender, filter_jury, filter_country, value, filter_name)
                _getData(filter_query)
                break;
            case "name":
                setFilterName(value)
                filter_query = _getFilterQuery(filter_size, filter_gender, filter_jury, filter_country, filter_city, value)
                _getData(filter_query)
                break;

            default:
                break;
        }
    }


    function FilterRatings() {
        return (
            <div className="cms-ratings-filter">
                <form
                    action=""
                    onSubmit={(e) => {
                        e.preventDefault();
                        _getData();
                    }}
                >
                    <div className="filter-container">
                        {/* <div className="mb-5 mr-5">
                                                <SelectTalent width={"230px"} value={filter_talent} callback={onValue} />
                                                <input type="hidden" name="talent" value={filter_talent} />

                                            </div> */}
                        <div className="mb-5">
                            <input
                                className="form-control cms-ratings-filter-input"
                                placeholder="Name"
                                style={{ width: 200 }}
                                type="text"
                                name="name"
                                defaultValue={filter_name}
                                onChange={(e) => {
                                    // setFilterName(e.target.value)
                                }}
                                onKeyDown={(ev) => {
                                    if (ev.key === 'Enter') {
                                        ev.preventDefault();
                                        onValue(ev.target.value, "name");
                                    }
                                }}
                            />
                        </div>
                        <div className=" mb-5 ">
                            <SelectJuries width={"150px"} value={filter_jury} callback={onValue} />
                            <input type="hidden" name="jury" value={filter_jury} />
                        </div>
                        <div className=" mb-5 ">
                            <SelectGender width={"180px"} value={filter_gender} callback={onValue} />
                            <input type="hidden" name="gender" value={filter_gender} />

                        </div>
                        <div className=" mb-5 ">
                            <SelectCountries kurds={1} value={filter_country} name="country" width="180px" border="1" callback={onValue} />
                            <input type="hidden" name="gender" value={filter_country} />

                        </div>
                        <div className=" mb-5 ">
                            <SelectCities country={filter_country} key={filter_country} value={filter_city} name="city" width="180px" border="1" callback={onValue} />
                            <input type="hidden" name="gender" value={filter_city} />

                        </div>
                        {/* <div className=" mb-5 ">
                                                <SelectCourses width={"190px"} value={filter_course} callback={onValue} />
                                                <input type="hidden" name="course" value={filter_course} />
                                            </div> */}

                        <div className=" mb-5 ">
                            <SelectSize width={"100px"} value={filter_size} callback={onValue} />
                            <input type="hidden" name="size" value={filter_size} />
                        </div>
                    </div>
                </form>
            </div>
        )
    }



    function DegreeItem({ courseparticipant, index }) {

        let usertalent = courseparticipant.usertalent;
        let course = courseparticipant.course;
        const { courseDocument: coursedocument, userDocument } = getParticipantDocs(courseparticipant);
        let user = usertalent.user;
        let profile = user.profile;

        let questions = courseparticipant.questions;


        let people_degree = courseparticipant.peopledegree_average.degree__avg
        if (people_degree) people_degree = people_degree.toFixed(2)

        return (
            <li
                key={courseparticipant.id}
                className="degree-item height-400 cms-ratings-card"
                style={{ animationDelay: `${Math.min(index * 38, 500)}ms` }}
            >
                <div className="talent" onClick={() => { openModal(userDocument, courseparticipant) }}>
                    <span style={{ fontSize: 11 }}>{getDefaultName(usertalent.talent.names)}</span>
                    <br />
                    <i className="fa fa-play "></i>
                </div>
                <div className={`index ${index < 10 ? "gold-box" : index < 30 ? "blue-box" : ""}`}>
                    {index + 1}
                </div>
                <div className="coursedocument">
                    <CourseDocumentPublicButton coursedocument={coursedocument} />
                </div>
                <div className="widget-user-header  text-center">
                    <div className="widget-user-image">
                        <a href={`/cms/usertalent/${profile.id}`} >
                            <img className="img-circle img-rating cms-ratings-avatar" title={profile.first_name + " " + profile.last_name} alt={profile.first_name + " " + profile.last_name}
                                src={profile.avatar ? userAvatar(profile) : profile.gender == "1" ? "assets/dist/img/avatar-f.jpeg" : "assets/dist/img/avatar-m.jpeg"} />
                        </a>
                    </div>

                </div>
                <table className="table table-degrees  ">
                    <tbody>
                        {
                            questions && questions.map(question_item => {
                                return (
                                    <DegreeProgress question_item={question_item} />
                                )
                            }
                            )}

                        <tr className="bg-audience" >
                            <th style={{ fontSize: "11px", width: 200, paddingLeft: 20 }} >Audience</th>
                            <th ></th>
                        </tr>
                        <AvgProgress avg={people_degree} onClick={() => {
                            // openPeopleDegreeModal(course, usertalent)
                        }} />
                        <tr className="pointer" onClick={() => {
                            openModal(userDocument, courseparticipant)
                        }}>
                            <td style={{ width: 180, paddingLeft: 20, }}>
                                <div className="">
                                    Total
                                </div>
                            </td>
                            <td><span title={`Referee total : ${courseparticipant.total_degree}`} className={BadgeClass(courseparticipant.total)}>
                                {
                                    courseparticipant.total
                                }
                            </span></td>
                        </tr>
                    </tbody>
                </table>

            </li>
        )
    }

    function DegreeItemSimple({ courseparticipant, index }) {

        let usertalent = courseparticipant.usertalent;
        let course = courseparticipant.course;
        const { courseDocument: coursedocument, userDocument } = getParticipantDocs(courseparticipant);
        let user = usertalent.user;
        let profile = user.profile;
        // let people_degree = courseparticipant.peopledegree_average.degree__avg
        // if(people_degree){
        //     people_degree = people_degree.toFixed(2)
        // }

        return (
            <li
                key={courseparticipant.id}
                className="degree-item no-padding cms-ratings-card"
                style={{ animationDelay: `${Math.min(index * 38, 500)}ms` }}
            >
                <div className="simple-rating-talent" onClick={() => { openModal(userDocument, courseparticipant) }}>
                    <i className="fa fa-play "></i>
                </div>
                <div className={`index-right ${index < 10 ? "gold-box" : index < 30 ? "blue-box" : ""}`}>
                    {index + 1}
                </div>
                <div className="coursedocument-simple">
                    <CourseDocumentPublicButton coursedocument={coursedocument} />
                </div>
                <div className="simple-rating-container">
                    <div className="widget-user-header ">
                        <div className="widget-user-image">
                            <a href={`/cms/usertalent/${profile.id}`} >
                                <img className="img-circle img-rating cms-ratings-avatar" title={profile.first_name + " " + profile.last_name} alt={profile.first_name + " " + profile.last_name}
                                    src={profile.avatar ? userAvatar(profile) : profile.gender == "1" ? "assets/dist/img/avatar-f.jpeg" : "assets/dist/img/avatar-m.jpeg"} />
                            </a>
                        </div>
                        <span title={`Referee total : ${courseparticipant.total_degree}`} className={BadgeClass(courseparticipant.total_degree)}>
                            {
                                courseparticipant.total
                            }
                        </span>
                    </div>
                </div>
            </li>
        )
    }

    return (
        <div className="wrapper">
            <Navbar />
            <Mainmenu />
            <div className="content-wrapper cms-ratings-page">
                
                <section className="content">
                    <div className="container-fluid" style={{ maxWidth: '1400px' }}>
                        <div className="box box-primary">

                                <div className="box-header with-border">
                                    <h3 className="box-title">
                                        Ratings
                                        <span style={{ fontSize: 11, marginLeft: '0.35em' }}>
                                            ({(simpleView
                                                ? defaultCourseParticipants?.length
                                                : courseparticipants?.length) ?? 0}
                                            )
                                        </span>
                                    </h3>
                                    <a href="#refresh" onClick={(e) => {
                                        e.preventDefault();
                                        if (loading) return;
                                        _getData();
                                    }} className="btn btn-cm margin-r-5 pull-right" title="Refresh">
                                        {loading ? <i className="fa fa-spinner fa-spin"></i> : <i className="fa fa-refresh"></i>}
                                    </a>
                                    <a href="/cms/ratings" className="btn btn-cm margin-r-5 pull-right" title="Back to contests">
                                        <i className="fa fa-arrow-left"></i>
                                    </a>
                                    <a href="#view" onClick={(e) => {
                                        e.preventDefault();
                                        setSimpleView(!simpleView);
                                        _getData();
                                    }} className="btn btn-cm margin-r-5 pull-right" title={simpleView ? 'Full detail view' : 'Simple view'}>
                                        <i className={`fa ${simpleView ? 'fa-th-large' : 'fa-list'}`}></i>
                                    </a>
                                </div>
                                <FilterRatings />
                                <div className="box-body p-4">
                                    <div className="table-responsive mailbox-messages cms-ratings-grid-wrap">
                                        <ul className="mailbox-attachments rating-documents cms-ratings-grid clearfix">
                                            {(simpleView && defaultCourseParticipants) && defaultCourseParticipants.map((item, index) =>
                                                <DegreeItemSimple key={"di" + index} courseparticipant={item} index={index} />
                                            )}
                                            {(!simpleView && courseparticipants) && courseparticipants.map((item, index) =>
                                                <DegreeItem key={"di" + index} courseparticipant={item} index={index} />
                                            )}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                    </div>
                </section>
            </div>
            <Footer />
            <Modal
                closeTimeoutMS={500}
                isOpen={modalIsOpen}
                onRequestClose={closeModal}
                className="Modal"
                overlayClassName="Overlay"
            >
                <div className="modal-content">
                    <div className="modal-header">
                        <button type="button" className="close" onClick={closeModal}>
                            <span aria-hidden="true">&times;</span>
                        </button>
                        <h4 className="modal-title"> </h4>
                    </div>
                    <div className="modal-body text-center">

                        {current_document && isImage(current_document.file) &&
                            <img src={resolveMediaUrl(current_document.file) || current_document.file} alt="" className="modal-img" />

                        }

                        {current_document && current_document.url &&
                            <UrlEmbed height="400" url={current_document.url} />
                        }
                    </div>

                </div>
            </Modal>

        </div>
    )
}

export default RatingsSummary